import axios from "axios";
import { Config, ConfigMember } from "../config";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "react-responsive";

interface ApiResponse {
  data: {
    data: string[];
  };
}

export const Article = async () => {
  try {
    let props = JSON.stringify({
      limit: 12,
      offset: 0,
    });

    const data = await axios<any>({
      method: "post",
      maxBodyLength: Infinity,

      url: ConfigMember.apiEndpoint + `v1/article/home-highlight-article`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
      data: props,
    });

    return data.data;
  } catch (error) {}
};

export const ArticleDetail = async (token: string) => {
  try {
    let dataArticleDetail = JSON.stringify({
      slug: 9,
      preview: true,
    });

    const data = await axios<ApiResponse>({
      method: "post",
      maxBodyLength: Infinity,
      url: ConfigMember.apiEndpoint + `v1/article/get-article-details`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: dataArticleDetail,
    });
    return data.data;
  } catch (error) {}
};

export const ActivityDetail = async () => {
  try {
    let dataActivityDetail = JSON.stringify({
      limit: 10,
    });
    const data = await axios<any>({
      method: "post",
      maxBodyLength: Infinity,
      url: ConfigMember.apiEndpoint + `v1/article/home-highlight-activity`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
      data: dataActivityDetail,
    });
    return data.data;
  } catch (error) {}
};

export const Detail = async (token: string, props: any) => {
  try {
    const data = await axios<ApiResponse>({
      method: "post",
      maxBodyLength: Infinity,

      url: Config.apiEndpoint + `article/get-article-detail`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: props,
    });
    return data.data;
  } catch (error) {}
};

export const GetAllArticleActivity = async (
  limit: number,
  offset: number,
  tagId: number,
  articleType: number,
  keyword: string
) => {
  try {
    let dataBody = JSON.stringify({
      limit: limit,
      offset: offset,
      tagId: tagId,
      articleType: articleType,
      keyword: keyword,
    });

    const response = await axios({
      method: "post",
      maxBodyLength: Infinity,
      url: `${ConfigMember.apiEndpoint}v1/article/get-all-article`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
      data: dataBody,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response);
        return error.response.data;
      }
      console.error("Error message:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    return { error: "An error occurred while fetching articles." };
  }
};

export const GetAllArticleTag = async () => {
  try {
    const response = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url: `${ConfigMember.apiEndpoint}v1/article/get-all-article-tag`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response);
        return error.response.data;
      }
      console.error("Error message:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    return { error: "An error occurred while fetching articles." };
  }
};

export const GetAllArticleDetail = async (
  token: string,
  slug: string,
  recommendLimit: number
) => {
  try {
    let dataBody = JSON.stringify({
      slug: slug,
      recommendLimit: recommendLimit,
    });

    const response = await axios({
      method: "post",
      maxBodyLength: Infinity,
      url: `${ConfigMember.apiEndpoint}v1/article/get-article-details`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
      data: dataBody,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("Error response:", error.response);
        return error.response.data;
      }
      console.error("Error message:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    return { error: "An error occurred while fetching articles." };
  }
};
